import React, { useState, useEffect } from 'react';
import { Form, Input, Button } from 'antd';
import Typing from '../Typing/Typing';
import * as Utils from '../../services/utils';
import CmpsAnimation from '../CmpsAnimation/CmpsAnimation';
import Timestamp from '../../components/Timestamp/Timestamp'
import CmpsMsgStatus from '../CmpsMsgStatus/CmpsMsgStatus';
import { ReactComponent as Submit } from '../../assets/images/submit.svg';

function CmpsName({onComplete, onScroll, form, onShowInput}) {
  const [typing, setTyping] = useState(true);
  const [msg, setMsg] = useState(false);
  const [validInput, setValidInput] = useState(false);

  const send = (e) => {
    setMsg(form.getFieldValue("nome"));
    onComplete('step7');
  }

  const onInputChange = async () => {
    try {
      const values = await form.validateFields(['nome']);
      // Valid
      setValidInput(true);
    } catch (errorInfo) {
      // Not valid
      setValidInput(false);
    }
  };

  useEffect(() => {
    Utils.eventsDataLayer('customPageview', '/chatbot-fissa-appuntamento/nome');
    onShowInput(false);
    const timer = setTimeout(() => {
      setTyping(false);
      onShowInput(true);
      onScroll();
    }, 2200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section id="cmps-name">
      {typing && <Typing wait={1200} />}
      {!typing && (
        <div className="messages messages--receiver">
          <div className="message">
            <CmpsAnimation wait={300}>
              <span className="bubble">Per completare la richiesta mi<br /> servirebbero alcuni tuoi dati<br /> personali.</span>
            </CmpsAnimation>
            <CmpsAnimation wait={600} last={true}>
              <span className="bubble">Qual è il tuo nome?</span>
              <div className="info">
                <span className="time"><Timestamp /></span>
              </div>
            </CmpsAnimation>
          </div>
        </div>
      )}
      {msg && (
        <div className="messages messages--sender">
          <CmpsAnimation wait={300}>
            <div className="message">
              <span className="bubble">{msg}</span>
            </div>
            <div className="info">
              <span className="time"><Timestamp /></span>
              <CmpsMsgStatus />
            </div>
          </CmpsAnimation>
        </div>
      )}
      <div className={`cmps_input ${!typing && !msg ? 'show' : ''}`} >
        <Form.Item 
          name="nome"
          rules={[
            { required: true, message: "richiesto" },
          ]}
        >
            <Input placeholder="Scrivi qui" autoComplete="off" onChange={onInputChange} />
        </Form.Item>
        <Button className={['cmps_btn__send']} onClick={send} disabled={!validInput}>
          <Submit className="icon-cmps-submit" />
        </Button>
      </div>
    </section>
  );
  
} 

export default CmpsName;